var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.05369 10.5309C7.75994 10.8246 7.28494 10.8246 6.99431 10.5309L1.99119 5.53086C1.69744 5.23711 1.69744 4.76211 1.99119 4.47148C2.28494 4.18086 2.75994 4.17773 3.05056 4.47148L7.51931 8.94024L11.9912 4.46836C12.2849 4.17461 12.7599 4.17461 13.0506 4.46836C13.3412 4.76211 13.3443 5.23711 13.0506 5.52773L8.05369 10.5309Z",
    fill: "#E2E2E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.c9a76107a0e834094af62290e9e7c756.svg";
export { ForwardRef as ReactComponent };